export default "__VITE_ASSET__CnrRGj1A__"